module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhBAMAAAClyt9cAAAAG1BMVEUAAAD////////////////////////////////rTT7CAAAACHRSTlMAwPPGIrwgH1Ba8nAAAAA8SURBVCjPY4ACR1UHBlRg0WGAJtLR0TC8RAo7UEBjAkNEByoQYNBAE1HAVINpzqDzKaUiBNOGoyIs/QAAkYJTLWppCdsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_yellow/plus.png
// module id = Knmv
// module chunks = 1